<breadcrumb endText="Logs" [navigations]="breadcrumbNavs" />
@if (importLogDetail) {
  <div class="fixed w-screen h-screen bg-gray-600 top-0 bottom-0 left-0 right-0 overflow-hidden bg-opacity-60 z-30">
    <div class="h-full w-full">
      <div class="min-w-[500px] sampleFile">
        <div class="flex flex-col h-full w-full p-5 overflow-y-hidden">
          <div class="flex-none">
            <div class="flex flex-row justify-between pb-1">
              <p class="text-center font-semibold text-xl">Import Log Details</p>
              <clear-button (click)="exitLogDetail()" [faIcon]="faXmark" text="Exit" />
            </div>
            <hr class="-mx-5"/>
            @if (detailLog != null) {
              <div>
                @if (detailLog.allnew !== 0) {
                  <div>
                    <div class="mt-1 rounded-[4px] border border-[#CBD1D7] p-1.5 bg-[#F6F7F8]">
                      New Users Added: {{detailLog.allnew}}
                    </div>
                    <p class="text-[#74808B] text-xs pl-1.5">Brand new users</p>
                  </div>
                }
                @if (detailLog.justroles !== 0) {
                  <div>
                    <div class="mt-1 rounded-[4px] border border-[#CBD1D7] p-1.5 bg-[#F6F7F8]">
                      Existing Users with New Roles: {{detailLog.justroles}}
                    </div>
                    <p class="text-[#74808B] text-xs pl-1.5">Users had this role added to them</p>
                  </div>
                }
                @if (detailLog.nochange !== 0) {
                  <div>
                    <div class="mt-1 rounded-[4px] border border-[#CBD1D7] p-1.5 bg-[#F6F7F8]">
                      Users with No Change: {{detailLog.nochange}}
                    </div>
                    <p class="text-[#74808B] text-xs pl-1.5">Users that already exist with this role</p>
                  </div>
                }
                @if (detailLog.nouname !== 0) {
                  <div>
                    <div class="mt-1 rounded-[4px] border border-[#CBD1D7] p-1.5 bg-[#F6F7F8]">
                      No Username Users: {{detailLog.nouname}}
                    </div>
                    <p class="text-[#74808B] text-xs pl-1.5">Users within the .csv that did not have a username provided</p>
                  </div>
                }
                @if (detailLog.noemail !== 0) {
                  <div>
                    <div class="mt-1 rounded-[4px] border border-[#CBD1D7] p-1.5 bg-[#F6F7F8]">
                      No Email Users: {{detailLog.noemail}}
                    </div>
                    <p class="text-[#74808B] text-xs pl-1.5">Users within the .csv that did not have an email provided</p>
                  </div>
                }
                @if (detailLog.errors !== 0) {
                  <div>
                    <div class="mt-1 rounded-[4px] border border-[#CBD1D7] p-1.5 bg-[#F6F7F8]">
                      Error Users: {{detailLog.errors}}
                    </div>
                    <p class="text-[#74808B] text-xs pl-1.5">Unknown error adding these users</p>
                  </div>
                }
                @if (detailLog.badroles !== 0) {
                  <div>
                    <div class="mt-1 rounded-[4px] border border-[#CBD1D7] p-1.5 bg-[#F6F7F8]">
                      Incomplete Users: {{detailLog.badroles}}
                    </div>
                    <p class="text-[#74808B] text-xs pl-1.5">Users with incomplete info</p>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}
<div class="m-5">
  <div>
    <p class="font-medium text-2xl mb-1">
      Auto Import Log
    </p>
    <hr />
  </div>
  <div class="grid grid-cols-4 lg:w-[80%] mt-3 text-sm text-left">
    <div class="col-span-2">
      <b>
        Message
      </b>
    </div>
    <div>
      <b>
        Date
      </b>
    </div>
    <div>
      <b>
        Time
      </b>
    </div>
    <hr class="col-span-4 mt-1"/>
    @for (log of logs; track log) {
      <button (click)="openLogDetail(log)" class="col-span-4 rounded-[4px] p-1 hover:bg-gray-200 grid grid-cols-4 mt-1 text-left">
        <div class="col-span-2">{{log.error_msg}}</div>
        <div>{{log.timestamp | date: 'MM/dd/y'}}</div>
        <div>{{log.timestamp | date: 'HH:mm:ss'}}</div>
      </button>
    }
    <div class="col-span-5 mt-1 flex justify-end">
      @if (maxPage !== 0) {
        <div class="rounded-full bg-[#E5E8EB] w-fit px-2 py-1 text-xs text-[#74808B] flex flex-row items-center">
          <button (click)="decrementPage()" [disabled]="pageNumber === 0"><fa-icon [ngClass]="pageNumber === 0? 'text-[#B9C2CA]' : 'text-[#74808B]'" [icon]="faChevronLeft" size="xs" aria-label="Decrement Page" /></button>
          <div class="mx-1">
            Page {{pageNumber + 1}}
          </div>
          <button (click)="incrementPage()" [disabled]="maxPage === pageNumber"><fa-icon [ngClass]="maxPage === pageNumber? 'text-[#B9C2CA]' : 'text-[#74808B]'" [icon]="faChevronRight" size="xs" aria-label="Increment Page" /></button>
        </div>
      }
    </div>
  </div>
</div>
